import Fragment from "./fragment";
import FragmentDataType from "../enums/fragment-data-type";
import FragmentSummary from "./fragment-summary";

export default class SwapTeams extends Fragment {
    constructor() {
        super();
        this.swapTeams = null;

        this.requiredData = [
            {
                name: "swapTeams",
                type: FragmentDataType.SwapTeams,
                displayName: "Swap Teams",
                isEditable: false
            }
        ];
    }

    updateSummaryContext(summaryContext) {
        summaryContext.sopPrinted = true;
        summaryContext.eopPrinted = true;
    }

    summarize(summaryContext) {
        const { homeTeam, awayTeam } = summaryContext;
        const teamOrder = this.swapTeams
            ? [homeTeam, awayTeam]
            : [awayTeam, homeTeam];
        return new FragmentSummary(
            `Teams swapped: ${teamOrder.map((t) => t.teamName).join(" <-> ")}`
        );
    }
}
